import { useEffect, useMemo, useState } from 'react'
import { get } from 'lodash'
import algoliasearch from 'algoliasearch/lite'
import {
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY,
  COACH_ACTIVITIES_INDEX_NAME,
} from 'env'
import { buildActivityIdsFilter } from '../lib/algolia-filters'

const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY)

const useCoachActivityHits = planHit => {
  const [hits, setHits] = useState([])
  const [resolvedPlanId, setResolvedPlanId] = useState(null)

  const planId = planHit?.objectID
  const activityIds = useMemo(() => {
    if (!planHit) {
      return []
    }

    return get(planHit, 'sections', []).flatMap(
      section => section.activities || [],
    )
  }, [planHit])

  const needsActivityFetch = Boolean(planId && activityIds.length > 0)
  const isLoading = needsActivityFetch && resolvedPlanId !== planId

  useEffect(() => {
    if (!planHit) {
      setHits([])
      setResolvedPlanId(null)
      return undefined
    }

    if (activityIds.length === 0) {
      setHits([])
      setResolvedPlanId(planId)
      return undefined
    }

    let isMounted = true

    setHits([])

    searchClient
      .search([
        {
          indexName: COACH_ACTIVITIES_INDEX_NAME,
          params: {
            filters: buildActivityIdsFilter(activityIds),
            hitsPerPage: activityIds.length,
          },
        },
      ])
      .then(({ results }) => {
        if (isMounted) {
          setHits(results[0]?.hits || [])
        }
      })
      .catch(() => {
        if (isMounted) {
          setHits([])
        }
      })
      .finally(() => {
        if (isMounted) {
          setResolvedPlanId(planId)
        }
      })

    return () => {
      isMounted = false
    }
  }, [activityIds, planHit, planId])

  return { hits, isLoading }
}

export default useCoachActivityHits
